<template>
    <v-btn
        class="btn-info"
        dark
        x-small
        fab
        @click="showItem(data)"
        outlined
    > <v-icon dark>
        mdi-eye
    </v-icon></v-btn>
</template>

<script>

    export default {
        props:{
            data:{},
            showItem: {
                type: Function,
            },
            meta: {
                type: Object,
                default: () => ({}),
            },
        }


    }
</script>
